import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GetActiveAnnouncementsResponse } from '@app/generated-api';
import { AnnouncementService } from '@app/v2/services/announcement/announcement.service';
import {
    MdsButtonComponent,
    MdsDialogActionsComponent,
    MdsDialogComponent,
    MdsDialogContentComponent,
    MdsDividerComponent,
} from '@medpacesoftwaredevelopment/designsystem';
import { EnvConfigurationService } from '@services/env/env-configuration.service';

export interface AnnouncementModalVm {
    announcements: GetActiveAnnouncementsResponse[];
    showRedirectToRequests: boolean;
}

@Component({
    selector: 'medpace-display-announcement-dialog',
    imports: [
        MdsDialogComponent,
        MdsDialogContentComponent,
        MdsDividerComponent,
        MdsDialogActionsComponent,
        MdsButtonComponent,
    ],
    templateUrl: './display-announcement-dialog.component.html',
    styleUrl: './display-announcement-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayAnnouncementDialogComponent {
    private dialogRef = inject(MatDialogRef<DisplayAnnouncementDialogComponent>);
    constructor(
        @Inject(MAT_DIALOG_DATA) public vm: AnnouncementModalVm,
        private router: Router
    ) {}

    private announcementService = inject(AnnouncementService);
    private envConfigurationService = inject(EnvConfigurationService);
    applicationName = this.envConfigurationService.configuration.applicationName;
    redirectToRequestPage() {
        this.close();
        this.router.navigate(['requests', 'pending-site-verification']);
    }

    /* istanbul ignore next */
    protected close() {
        if (this.vm?.announcements?.length > 0) {
            this.setAnnouncementsToSessionStorage(this.vm.announcements);
        }
        sessionStorage.setItem('showRedirectToRequests', 'false');
        this.dialogRef.close();
    }

    setAnnouncementsToSessionStorage(announcements: GetActiveAnnouncementsResponse[]) {
        //list passed unique announcement ids
        this.announcementService.setAnnouncementIdsIntoSessionStorage(
            announcements.map((x) => x.id).filter((id, i, arr) => arr.findIndex((t) => t == id) === i)
        );
    }
}
